









































































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { Apis, Factories } from '@finx/web-repository'
import Moment from 'moment'
import { Producao } from '@/types/_'
import ProducaoVuex from '@/store/ProducaoVuex'
import _ from 'lodash'

@Component

export default class ComponentProducaoCardList extends Vue {
  @Prop({ type: Object as () => Producao }) producao

  loading: any = {
    status: false,
    text: '',
  }

  showDetail: Boolean = false
  removeShow: Boolean = true
  statusProducao: Boolean = false

  get getStatusProducao() {
    return this.statusProducao
  }

  set getStatusProducao(value) {
    this.statusProducao = value
  }

  get totalPages(): number {
    return ProducaoVuex.getters.TOTAL_PAGES
  }

  set totalPages(value) {
    ProducaoVuex.commit('SET_TOTAL_PAGES', value)
  }

  get totalRevisao() {
    return ProducaoVuex.getters.TOTAL_REVISAO
  }

  get bloquearGestao(): boolean {
    return ProducaoVuex.getters.BLOQUEAR_GESTAO
  }

  set totalRevisao(value) {
    ProducaoVuex.commit('SET_TOTAL_REVISAO', value)
  }

  disabledRevisar(producao) {
    if (!producao.permisaoRevisar) return true

    return producao.revisado
  }

  showDetails() {
    this.showDetail = !this.showDetail
  }

  formatarData(data) {
    return Moment(data).format('DD/MM/YY')
  }

  redirectEditarProducao(producaoId, operadora) {
    ProducaoVuex.commit('SET_PAGE', 0)

    if (operadora !== undefined && operadora !== '' && operadora === 'PLANTÃO') {
      this.redirect(`/plantao/editar/${producaoId}`)
    } else {
      this.redirect(`/provisao/editar/${producaoId}`)
    }
  }

  redirect(url): void {
    this.$router.push(url)
  }

  statusColor(producao) {
    if (producao.revisado) {
      return '#00BC73'
    }

    return this.getStatusProducao ? '#00BC73 ' : '#F5A623'
  }

  statusMensagem(producao) {
    return producao.revisado || this.getStatusProducao ? 'Revisado' : 'Revisar'
  }

  colorStatus(producao) {
    if (producao.statusPagamento === undefined) return '#fff'
    switch (producao.statusPagamento.key) {
      case 'Agendado':
        return '#f5b66f'
      case 'Solicitado':
        return '#f5b66f'
      case 'Faturado':
        return '#3F6BB2'
      case 'Realizado':
        return '#3F6BB2'
      case 'PagamentoAberto':
        return '#B7BABB'
      case 'PagoParcial':
        return '#00BC73'
      case 'Pago':
        return '#00BC73'
      default:
        return '#fff'
    }
  }

  async revisarProducao(producaoId) {
    this.loading.status = true
    this.loading.text = 'Carregando...'

    this.alertDialog(this.loading)

    const request = await Apis.Legacy.Producao.revisarProducao(producaoId)

    const success = Factories.Apis.success(request)
    if (success) {
      this.statusProducao = true
      this.producao.revisado = true
      this.totalRevisao = this.totalRevisao - 1
    }

    this.loading.status = false
    this.alertDialog(this.loading)
  }

  async removeProducao(producaoId) {
    this.loading.status = true
    this.loading.text = 'Excluindo registro...'
    this.alertDialog(this.loading)
    const request = await Apis.Legacy.Producao.removeProducao(producaoId)
    const success = Factories.Apis.success(request)
    this.loading.status = false
    this.alertDialog(this.loading)
    this.removeShow = false

    if (this.totalPages > 0) {
      this.totalPages = this.totalPages - 1
    }
  }

  capitalizeCase(value: string) {
    return _.startCase(_.toLower(value))
  }

  @Emit('alertDialog')
  alertDialog(message) { }
}
